function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-humidity-high",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "humidity-high",
  transform: "translate(2.000000, 2.000000)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.7561404,28.7629386 C22.7561404,32.0804017 25.4454755,34.7697368 28.7629386,34.7697368 C32.0804017,34.7697368 34.7697368,32.0804017 34.7697368,28.7629386 C34.7697368,24.2574561 31.7655702,18.2506579 28.7629386,15.2541667 C25.1557888,18.8571063 23.0151502,23.6712181 22.7561404,28.7629386 L22.7561404,28.7629386 Z",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#485156",
  cx: 14.0460526,
  cy: 14.0460526,
  r: 2.30263158
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.3065789,27.4780702 C9.99081981,29.2523407 2.60114126,24.8432565 0.688066838,17.5625619 C-1.22500758,10.2818673 3.04274875,2.80967702 10.2857455,0.758490637 C17.5287423,-1.29269574 25.0807418,2.83218918 27.2692982,10.0348684",
  id: "Path",
  stroke: "#485156",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.3620614,7.98245614 C16.2988114,5.29677068 11.7127049,5.32057337 8.67749749,8.03791089 C5.64229013,10.7552484 5.11334386,15.3108116 7.44517544,18.6513158",
  id: "Path",
  stroke: "#425CD4",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.6469298,18.6513158 C21.5954614,17.3029218 22.104747,15.6946515 22.1052632,14.0460526",
  id: "Path",
  stroke: "#425CD4",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 15.7469298,
  y1: 12.4940789,
  x2: 20.9539474,
  y2: 5.98684211,
  id: "Path",
  stroke: "#485156",
  strokeLinecap: "round"
})));
function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / humidity-high") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.364099f768cb7591707597e73684127b.svg";
export { ForwardRef as ReactComponent };